import { useContext, createContext, useRef, useCallback } from 'react';
import { useForceUpdate } from '@wistia/vhs';

const CrossRouteUnsavedChangesContext = createContext({});

export const CrossRouteUnsavedChangesProvider = ({ children }) => {
  const unsavedChanges = useRef(new Set());
  const hasUnsavedChanges = unsavedChanges.current.size > 0;
  const forceUpdate = useForceUpdate();

  const addUnsavedChanges = useCallback(
    (hashable) => {
      unsavedChanges.current.add(hashable);
      forceUpdate();
    },
    [forceUpdate],
  );

  const deleteUnsavedChanges = useCallback(
    (hashable) => {
      unsavedChanges.current.delete(hashable);
      forceUpdate();
    },
    [forceUpdate],
  );

  // eslint-disable-next-line react/jsx-no-constructed-context-values
  const value = { hasUnsavedChanges, addUnsavedChanges, deleteUnsavedChanges };

  return (
    <CrossRouteUnsavedChangesContext.Provider value={value}>
      {children}
    </CrossRouteUnsavedChangesContext.Provider>
  );
};

export const useCrossRouteUnsavedChanges = () => {
  return useContext(CrossRouteUnsavedChangesContext);
};
